import { useSelector } from 'react-redux';
import { ReportsInfo } from '../../models';
import { selectComplianceCentralReportsInfo } from '../../selectors';

export const useComplianceCentralReportsInfo = (): ReportsInfo[] | null => {
  const reportsInfo = useSelector(selectComplianceCentralReportsInfo);

  return reportsInfo;
};
